module.exports = __webpack_public_path__ + "../resources/img/ic_rain_light_weather.2371d5d7.svg";